import React from 'react';

export default class NullErrorBoundary extends React.Component {
  state = { error: null };

  componentDidCatch(error, info) {
    this.setState({ error });
    console.error(error, info); // eslint-disable-line no-console
  }

  render() {
    return this.state.error ? null : this.props.children;
  }
}
